import type { SelectOption } from '../types'

export const PS_TYPES = {
  PATENTABILITY: {
    value: 'patentability',
    label: 'Patentability',
    description:
      'A patentability search is made to identify patents and non-patent literature which may affect the patentability of an invention. This search is recommended to applicants to be done before writing and filing the patent specification, and as such is sometimes called a pre-application search.',
  },
  FREEDOM_TO_OPERATE: {
    value: 'freedom_to_operate',
    label: 'Freedom-to-operate',
    description:
      'A freedom-to-operate or clearance search is used to assess whether your invention may infringe on an existing patent, potentially leading to a lawsuit. A successful patent infringement lawsuit may result in monetary compensation to the patent holder, or even an injunction to stop sales and production.',
  },
  VALIDITY: {
    value: 'validity_invalidity',
    label: 'Validity / Invalidity',
    description:
      'An invalidity or opposition search is to identify patent and non-patent documents which may impact the claims of a specific patent. This can help block patents and establish solidity of a patent portfolio which may be useful for licensing or company acquisition.',
  },
}

export const PS_PROGRESS: Record<string, SelectOption> = {
  SUBMITTED: { value: 1, label: 'Submitted' },
  // REVIEW: { value: 2, label: 'Review' },
  IN_PROGRESS: { value: 3, label: 'In Progress' },
  DECLINED: { value: 4, label: 'Declined' },
  // CANCELLED: { value: 5, label: 'Cancelled' },
  COMPLETED: { value: 6, label: 'Completed' },
}

export const PS_REPORTING_FORMAT_OPTIONS = [
  {
    value: 'tier_one',
    label: 'Tier 1',
    description:
      'Includes basic bibliographic information of provided references',
  },
  {
    value: 'tier_two',
    label: 'Tier 2',
    description:
      'Includes specific document locations within the references that may be relevant or of interest',
  },
  {
    value: 'tier_three',
    label: 'Tier 3',
    description:
      'Organizes references into categories according to the elements/features of the search request',
  },
  {
    value: 'tier_four',
    label: 'Tier 4',
    description:
      'Provides a chart that maps and correlates the top reference(s) to the core elements/features of the search request',
  },
]
